import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { transitionDuration } from '../../const/transitionDuration';
import { transitionTimingFunction } from '../../const/transitionTimingFunction';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { useIsOpenTestAttribute } from '../inputs/useIsOpenTestAttribute';
import { Box } from '../layout/Box';
const StyledContainer = styled('div', (p) => ({
    display: 'grid',
    gridTemplateRows: p.$open ? '1fr' : '0fr',
    transitionProperty: 'grid-template-rows',
    transitionDuration: transitionDuration.medium,
    transitionTimingFunction: transitionTimingFunction.ease,
}));
export const Collapsible = ({ children, open, testId }) => {
    const isOpenTestAttribute = useIsOpenTestAttribute(open);
    const testIdAttribute = useTestIdAttribute(testId);
    return (_jsx(StyledContainer, { $open: open, ...isOpenTestAttribute, ...testIdAttribute, children: _jsx(Box, { overflow: 'hidden', children: children }) }));
};
